import React, {Fragment} from "react";
import Icon from "../../../Icon";
import PropsProxy from "../../../../layout/PropsProxy";
import {FilterType} from "../Types/FilterType";
import {ColumnProps} from "../Types/ColumnProps";

type FilterProps = ColumnProps & {
    filter?: FilterType,
    filterOpened: boolean,
    setFilter: (filter: FilterType|undefined|null) => void,
    setFilterOpened: (filterOpened: boolean) => void,
}

export default class FilterComp extends React.Component<FilterProps, any> {

    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
    }

    toggle(event) {
        event && event.preventDefault();
        event && event.stopPropagation();
        this.props.setFilterOpened(!this.props.filterOpened);
    }

    render() {
        return (
            <Fragment>
                <div
                    className="filter-button"
                    onClick={this.toggle}
                >
                    <Icon name="search"/>
                </div>
                <div
                    className={(this.props.filterOpened ? "filter-enabled" : "filter-disabled")}
                >
                    <div className="filterinput">
                        <PropsProxy {...this.props}>
                            {this.props.children}
                        </PropsProxy>
                    </div>
                </div>
            </Fragment>
        );
    }
}